module.exports = "<header>\n  <nav>\n    <span><a [routerLinkActive]=\"['currLink']\" routerLink=\"/contacts\">Contacts</a></span>\n    <span><a [routerLinkActive]=\"['currLink']\" routerLink=\"/skills\">Skills</a></span>\n    <span><a [routerLinkActive]=\"['currLink']\" routerLink=\"/about\">About</a></span>\n  </nav>\n</header>\n<router-outlet></router-outlet>\n\n\n"


//////////////////
// WEBPACK FOOTER
// E:/Java/ResumeAngular/resume/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main